// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sc__inner {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.sc__wrapper {
  display: block;
  width: 100%;
  height: 300px;
  max-width: 300px;
  margin: 0 auto;
}

.sc__container {
  position: relative;
  height: 300px;
  max-width: 300px;
}

.sc__container > img {
  position: relative;
  top: 190px;
  left: 0;
  height: auto;
}

.sc__container canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
}

.sc__infos {
  text-align: center;
  height: 40px;
  line-height: 40px;
  margin-top: 5px;
  font-weight: bold;
  font-size: 18px;
}

.result-img {
  z-index: -1;
}

.sc__canvas {
  margin-top: -180px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/campaign/play/scratch-card/scratch-card.component.scss"],"names":[],"mappings":"AAGC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAFF;;AAIA;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAMA;EACE,kBAAA;EAEA,aAAA;EACA,gBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,YAAA;AAJF;;AAOA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAJF;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAJF;;AAMA;EACE,WAAA;AAHF;;AAKA;EACE,kBAAA;AAFF","sourcesContent":["@use '../../../../../assets/styles/colors' as colors;\n@use '../../../../../assets/styles/bootstrap-essentials';\n\n .sc__inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.sc__wrapper {\n  display: block;\n  width: 100%;\n  height: 300px;\n  max-width: 300px;\n  margin: 0 auto;\n  // border: 5px solid white;\n  // margin-left: 100px;\n}\n\n.sc__container {\n  position: relative;\n  // overflow: hidden;\n  height: 300px;\n  max-width: 300px;\n}\n\n.sc__container > img {\n  position: relative;\n  top: 190px;\n  left: 0;\n  height: auto;\n}\n\n.sc__container canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: auto;\n}\n\n.sc__infos {\n  text-align: center;\n  height: 40px;\n  line-height: 40px;\n  margin-top: 5px;\n  font-weight: bold;\n  font-size: 18px;\n}\n.result-img{\n  z-index: -1;\n}\n.sc__canvas{\n  margin-top: -180px;\n}\n\n@include bootstrap-essentials.media-breakpoint-up(lg) {}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
